import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Ekologija v stilu",
  "description": "",
  "published": "2007-01-07T00:00:00.000Z",
  "redirect_from": ["/blog/ekologija-v-stilu/swizec/332"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Vsi imajo radi hitre avte kajne? No vsi normalni. In vsi radi skrbijo za okolje v katerem zivimo? No, to je vsaj trenutna moda. Poglejte si torej to `}<a parentName="p" {...{
        "href": "http://www.teslamotors.com/styling/body.php"
      }}>{`sexy bestijo`}</a>{`, tako je sexy, da jo hocem.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      